(function () {
  function readConfig(root) {
    try {
      return JSON.parse(root.querySelector('[data-quiz-config]').textContent);
    } catch (error) {
      console.warn('[MetzgerQuiz] invalid config', error);
      return null;
    }
  }

  class MetzgerQuiz {
    constructor(root) {
      this.root = root;
      this.config = readConfig(root);
      if (!this.config) return;

      this.card = root.querySelector('[data-quiz-card]');
      this.steps = Array.from(root.querySelectorAll('.r-metzger-quiz__progress span'));
      this.questions = this.config.questions || [];
      this.answers = {};
      this.step = 0;
      this.selectedGift = null;

      this.restoreGiftFromUrl();
      this.renderQuestion();
    }

    updateProgress(forceStep) {
      const current = typeof forceStep === 'number' ? forceStep : this.step;
      this.steps.forEach((node, index) => {
        node.classList.toggle('is-complete', index < current);
        node.classList.toggle('is-active', index === current);
      });
    }

    renderQuestion() {
      const question = this.questions[this.step];
      if (!question) {
        this.renderEmail();
        return;
      }

      this.updateProgress();
      const answerClass = question.type === 'truefalse'
        ? 'r-metzger-quiz__answers r-metzger-quiz__answers--truefalse'
        : 'r-metzger-quiz__answers';

      this.card.innerHTML = `
        <div class="r-metzger-quiz__question">
          <div class="r-metzger-quiz__question-kicker">Frage ${this.step + 1} von ${this.questions.length}</div>
          <h3 class="r-metzger-quiz__question-title">${question.text}</h3>
          <div class="${answerClass}">
            ${question.answers.map((answer, index) => `
              <button class="r-metzger-quiz__answer" type="button" data-answer="${answer.value}">
                <span class="r-metzger-quiz__answer-index">${String(index + 1).padStart(2, '0')}</span>
                <span>${answer.label}</span>
              </button>
            `).join('')}
          </div>
          ${question.feedback ? `<div class="r-metzger-quiz__feedback" hidden>${question.feedback}</div>` : ''}
          <button class="r-metzger-quiz__skip" type="button" data-skip>Direkt zur Bonus-Anmeldung</button>
        </div>
      `;

      this.card.querySelectorAll('[data-answer]').forEach((button) => {
        button.addEventListener('click', () => this.answer(question, button));
      });
      this.card.querySelector('[data-skip]').addEventListener('click', () => this.renderEmail());
    }

    answer(question, button) {
      this.answers[question.id] = button.dataset.answer;
      window.localStorage.setItem('metzger_quiz_answers', JSON.stringify(this.answers));
      this.card.querySelectorAll('[data-answer]').forEach((node) => node.classList.remove('is-selected'));
      button.classList.add('is-selected');

      const feedback = this.card.querySelector('.r-metzger-quiz__feedback');
      if (feedback) feedback.hidden = false;

      setTimeout(() => {
        this.step += 1;
        this.renderQuestion();
      }, feedback ? 1200 : 360);
    }

    determineGift() {
      const gifts = this.config.giftProducts || [];
      if (!gifts.length) return { title: 'Erster-Bestellbonus', handle: '', variantId: '', category: 'default' };
      const preference = this.answers.q4;
      return gifts.find((gift) => gift.category === preference) || gifts.find((gift) => gift.category === 'default') || gifts[0];
    }

    buildPayload(overrides = {}) {
      const gift = this.selectedGift || this.determineGift();
      return {
        first_order_gift: 'true',
        quiz_completed: 'true',
        quiz_gift_title: gift.title || 'Erster-Bestellbonus',
        quiz_gift_recommendation: gift.title || 'Erster-Bestellbonus',
        quiz_gift_handle: gift.handle || '',
        quiz_gift_variant: String(gift.variantId || ''),
        quiz_gift_category: gift.category || '',
        quiz_answers_digest: JSON.stringify(this.answers || {}),
        mystery_gift: 'true',
        staff_order_summary: 'ERSTE BESTELLUNG - MYSTERY GESCHENK BEILEGEN',
        quiz_completed_at: new Date().toISOString(),
        ...overrides
      };
    }

    renderEmail() {
      this.step = this.questions.length;
      this.updateProgress(this.step);
      this.selectedGift = this.determineGift();

      this.card.innerHTML = `
        <div class="r-metzger-quiz__email">
          <div class="r-metzger-quiz__gift">
            <div class="r-metzger-quiz__gift-kicker">Dein Bonus</div>
            <h3>Erster-Bestellbonus</h3>
            <p>Der Bonus wird deiner ersten Metzgerpaket-Bestellung als Hinweis beigefügt. Du startest danach mit Paketlinie, Größe und Intervall.</p>
          </div>
          <form class="r-metzger-quiz__form" data-quiz-form>
            <input type="email" name="email" autocomplete="email" placeholder="E-Mail" required>
            <button type="submit">Geschenk sichern</button>
          </form>
          <p class="r-metzger-quiz__privacy">Mit deiner Anmeldung erhältst du den Bonus und unseren Newsletter. Jederzeit abmeldbar. <a href="/policies/privacy-policy">Datenschutzerklärung</a></p>
        </div>
      `;

      this.card.querySelector('[data-quiz-form]').addEventListener('submit', (event) => this.submit(event));
    }

    async submit(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const button = form.querySelector('button');
      const email = form.elements.email.value.trim();
      button.disabled = true;
      button.textContent = 'Wird gesichert...';

      try {
        await this.sendToKlaviyo(email);
        await this.saveGift();
        this.renderSuccess();
      } catch (error) {
        console.error('[MetzgerQuiz] submit failed', error);
        button.disabled = false;
        button.textContent = 'Nochmal versuchen';
      }
    }

    async sendToKlaviyo(email) {
      if (!this.config.klaviyoListId) return;
      const params = new URLSearchParams();
      params.append('g', this.config.klaviyoListId);
      params.append('email', email);
      Object.entries(this.answers).forEach(([key, value]) => params.append(`quiz_${key}`, value));
      params.append('quiz_completed', 'true');
      params.append('$source', 'Metzgerpaket Quiz');

      if (window._learnq) {
        window._learnq.push(['identify', { '$email': email, quiz_completed: true, quiz_answers: this.answers }]);
        window._learnq.push(['track', 'Quiz Completed', { quiz_answers: this.answers }]);
      }

      const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded', 'cache-control': 'no-cache' },
        body: params
      });
      const data = await response.json();
      if (!data.success) throw new Error('Klaviyo subscription failed');
    }

    async saveGift() {
      const payload = this.buildPayload();
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: payload })
      });

      window.localStorage.setItem('metzger_quiz_gift', JSON.stringify(payload));
      window.dispatchEvent(new CustomEvent('metzger-quiz-complete', { detail: payload }));
    }

    renderSuccess() {
      this.updateProgress(7);
      this.card.innerHTML = `
        <div class="r-metzger-quiz__result">
          <div class="r-metzger-quiz__gift-kicker">Geschenk gesichert</div>
          <h3>Gespeichert. Jetzt Paket konfigurieren.</h3>
          <p>Dein Bonus ist für die erste Metzgerpaket-Bestellung hinterlegt. Wähle jetzt Paketlinie, Größe und Intervall.</p>
          <a class="r-metzger-quiz__continue" href="${this.config.selectorTarget}">Zum Metzgerpaket-Konfigurator</a>
        </div>
      `;
    }

    async restoreGiftFromUrl() {
      const params = new URLSearchParams(window.location.search);
      if (!params.has('restore_gift') && !params.has('mystery_gift')) return;
      const payload = this.buildPayload({ fromRestore: true, restoredBy: 'email_cta' });
      window.localStorage.setItem('metzger_quiz_gift', JSON.stringify(payload));
      window.dispatchEvent(new CustomEvent('metzger-quiz-complete', { detail: payload }));
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: payload })
      });
      window.history.replaceState({}, '', window.location.pathname);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-metzger-quiz]').forEach((root) => new MetzgerQuiz(root));
  });
})();
